import axios from 'axios'
import library from '../../../utils/Library'

export const createSuscriber = async (body) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('subscribers') + '/createSubscriberCorpEntities'

  return await axios({
    url: URL,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: body
  })
}
